var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7774 13.65L18.5693 15.2469C18.6773 15.4692 18.9653 15.6824 19.2083 15.7232L20.6436 15.9637C21.5615 16.1179 21.7775 16.7894 21.1161 17.4517L20.0002 18.5768C19.8112 18.7674 19.7077 19.1348 19.7662 19.398L20.0857 20.7907C20.3377 21.8931 19.7572 22.3196 18.7898 21.7434L17.4445 20.9404C17.2015 20.7953 16.801 20.7953 16.5536 20.9404L15.2082 21.7434C14.2453 22.3196 13.6604 21.8886 13.9124 20.7907L14.2318 19.398C14.2903 19.1348 14.1868 18.7674 13.9979 18.5768L12.882 17.4517C12.225 16.7894 12.4365 16.1179 13.3544 15.9637L14.7898 15.7232C15.0282 15.6824 15.3162 15.4692 15.4242 15.2469L16.2161 13.65C16.6481 12.7835 17.35 12.7835 17.7774 13.65Z",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.00009V4.00009M6 2.00009V4.00009",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 11.5001C21.4957 7.63373 21.4267 5.62812 20.2479 4.35373C18.9958 3.00009 16.9805 3.00009 12.95 3.00009H11.05C7.01949 3.00009 5.00424 3.00009 3.75212 4.35373C2.5 5.70737 2.5 7.88603 2.5 12.2433V12.7569C2.5 17.1142 2.5 19.2928 3.75212 20.6465C4.94594 21.9371 6.83349 21.9972 10.5 22",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.00009H21",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/Event.136311c72afc776b78ddfd6af6b4d57a.svg";
export { ForwardRef as ReactComponent };